class WishlistButton extends HTMLElement {
  connectedCallback() {
    // Guard against a second bind: a section re-render in the theme editor can
    // disconnect and reconnect the same element, and two listeners would make
    // every click toggle twice, i.e. do nothing visible.
    if (this.bound) return;
    this.bound = true;

    this.key = `wishlist:${this.dataset.productId}`;

    if (this.read() === '1') {
      this.setAttribute('active', '');
    }

    // Listen on the host, not on the inner button. connectedCallback can run
    // before the element's own children have been parsed, in which case
    // querySelector('button') is null and binding to it throws -- leaving the
    // heart looking fine and doing nothing at all when clicked.
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();

      if (this.hasAttribute('active')) {
        this.removeAttribute('active');
        this.write(null);
      } else {
        this.setAttribute('active', '');
        this.write('1');
      }
    });
  }

  // Storage is unavailable in private windows and with third-party cookies
  // blocked, where touching it throws. A wishlist that forgets is better than
  // a script that dies on load.
  read() {
    try {
      return localStorage.getItem(this.key);
    } catch (error) {
      return null;
    }
  }

  write(value) {
    try {
      if (value === null) {
        localStorage.removeItem(this.key);
      } else {
        localStorage.setItem(this.key, value);
      }
    } catch (error) {
      // Ignore -- the in-page state still reflects the click.
    }
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}
